import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Copy, LayoutTemplate, Palette } from "lucide-react";

export default function DesignsList() {
  const [designs, setDesigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => api.get("/designs").then((r) => { setDesigns(r.data); setLoading(false); }).catch(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!confirm("Delete this design?")) return;
    await api.delete(`/designs/${id}`); load();
  };
  const dup = async (id) => { await api.post(`/designs/${id}/duplicate`); load(); toast.success("Duplicated"); };

  return (
    <div className="space-y-6" data-testid="designs-list">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <div className="vp-label">Design studio</div>
          <h1 className="font-display font-black text-3xl sm:text-4xl mt-1 tracking-tight">Designs</h1>
          <p className="text-[#4A4D57] text-sm mt-2">Multi-page graphics — thumbnails, presentations, posters, social posts. Canva-parity editor.</p>
        </div>
        <Link to="/app/designer" className="vp-btn-primary inline-flex items-center gap-2" data-testid="new-design-btn">
          <Plus className="w-4 h-4" /> New design
        </Link>
      </div>

      {loading ? (
        <div className="text-center py-10 text-[#747680]">Loading…</div>
      ) : designs.length === 0 ? (
        <div className="vp-glass p-12 text-center">
          <Palette className="w-10 h-10 mx-auto text-[#C8CCD6]" />
          <div className="font-display font-black text-xl mt-4">No designs yet</div>
          <div className="text-sm text-[#4A4D57] mt-2 max-w-md mx-auto">Start from a template or a blank canvas. Multi-page, videos, brand kits, and AI background removal built-in.</div>
          <Link to="/app/designer" className="vp-btn-primary mt-6 inline-flex items-center gap-2"><Plus className="w-4 h-4" /> Create your first design</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {designs.map((d) => (
            <div key={d.id} className="vp-card group overflow-hidden" data-testid={`design-card-${d.id}`}>
              <Link to={`/app/designer/${d.id}`} className="block">
                <div className="aspect-video bg-gradient-to-br from-[#0B5CFF]/10 to-[#22D3EE]/10 flex items-center justify-center">
                  <LayoutTemplate className="w-10 h-10 text-[#0B5CFF]/40" />
                </div>
              </Link>
              <div className="p-3">
                <Link to={`/app/designer/${d.id}`} className="font-semibold text-sm text-[#0B0D17] truncate block">{d.title}</Link>
                <div className="text-xs text-[#747680] mt-0.5">{(d.pages || []).length} page{(d.pages || []).length !== 1 ? "s" : ""} · {d.kind}</div>
                <div className="flex gap-1 mt-3 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button onClick={() => dup(d.id)} className="text-xs px-2 py-1 rounded bg-[#F6F7FA] hover:bg-[#E4E6EC] inline-flex items-center gap-1"><Copy className="w-3 h-3" /> Duplicate</button>
                  <button onClick={() => del(d.id)} className="text-xs px-2 py-1 rounded bg-red-50 text-red-600 hover:bg-red-100 inline-flex items-center gap-1"><Trash2 className="w-3 h-3" /> Delete</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
